import { useGoogleAuth } from "@/hooks/useGoogleAuth";
import { useEffect } from "react";
import { useLocation } from "wouter";
import UserNoAccess from "@/pages/UserNoAccess";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isAuthenticated, loading } = useGoogleAuth();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      setLocation("/login");
    }
  }, [isAuthenticated, loading, setLocation]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  // Usuário com role "user" (sem permissão atribuída) vê tela de acesso pendente
  // sem o layout completo (sidebar, header, etc.)
  if (user?.role === "user") {
    return <UserNoAccess />;
  }

  // Cliente sem emitenteId: acesso permitido (controle feito via user_page_permissions)
  // O filtro de dados por emitente continua no backend (ctx.emitenteId = null = vê tudo)

  return <>{children}</>;
}
